<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <UsuarioSelect
            :rolesUsuarios="[6]"
            @usuario-seleccionado="usuarioId = $event">
        </UsuarioSelect>
        <ObrasSocialesTotSelect
            @os-seleccionada="obraSocialId = $event">
        </ObrasSocialesTotSelect>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            Asociar
        </v-btn>
    </v-form>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>
<style src="../assets/general.css"></style>
<script>
    import ObrasSocialesTotSelect from './ObrasSocialesTotSelect.vue';
    import UsuarioSelect from './UsuarioSelect.vue';
    import AuthService from '@/api/AuthService';
    import AlertComponent from './AlertComponent.vue';

    const authService = new AuthService();

    export default {
        components: {
            ObrasSocialesTotSelect,
            UsuarioSelect,
            AlertComponent
        },
        data() {
            return {
                usuarioId: null,
                obraSocialId: null,
                valid: false,
                cargando: false,
                //datos de alerta
                alertTitle: '',
                alertText: '',
                alertType: '',
                showAlert: false
            }
        },
        methods: {
            async handleSubmit() {
                this.cargando = true;
                const response = await authService.vincularOSAuditor(this.usuarioId, this.obraSocialId);
                if(response && response.status === 200) {
                    this.alertTitle = 'Operación exitosa';
                    this.alertText = 'La obra social ha sido asociada correctamente al auditor.';
                    this.alertType = 'success';
                } else {
                    this.alertTitle = 'Error';
                    this.alertText = response && response.data ? response.data : 'Ha ocurrido un error al asociar la obra social al auditor.';
                    this.alertType = 'error';
                }
                this.showAlert = true;
                this.cargando = false;
            }
        }
    }
</script>